import InlineSVG from '@boilerplates/inlineSvg'
import Loader from '@components/loader/1'
import { getFakeAddress, getLocation, getName, getStatus } from '@helpers/helper.developments'
import { ElementHTML, getCover, getQuality } from '@helpers/helper.rendering'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Development, RealEstateDataPageComponentData } from 'types'

interface Props {
  development: Development
  skeleton?: boolean
}

const CardDevelopment8 = (props: Props & RealEstateDataPageComponentData) => {
  const { development, global_data, skeleton } = props
  const { item, titleElement, titleColor } = global_data.content.cardsDevelopments.data
  const { divisionPath } = global_data

  if (skeleton) {
    return <div className="dev a card dev-card skeleton">{skeleton && <Loader />}</div>
  }

  return (
    <section
      id="card-development"
      className="cardDevelopment8"
    >
      <Row>
        <Col
          xs={12}
          className={`mb-5`}
        >
          <div className="img-container">
            <img
              src={getQuality(getCover(development?.photos))}
              alt="Portada de imagen emprendimiento"
              className={`img-card no-border`}
            />
            <div className="hover-content">
              <a
                target="_blank"
                href={
                  (divisionPath ?? '') +
                  '/emprendimiento/' +
                  getFakeAddress(development)
                    ?.replaceAll(' ', '-')
                    ?.replaceAll('/', '-')
                    ?.toLowerCase() +
                  '/' +
                  development?.id
                }
              >
                {item?.image && item?.isSvg ? (
                  <InlineSVG
                    src={item.image}
                    className="d-flex justify-content-center clickable"
                    onClick={() => {}}
                  />
                ) : (
                  <img src={item?.image} />
                )}
              </a>
            </div>
          </div>
          <ElementHTML
            elementType={titleElement ?? 'h3'}
            children={getName(development)}
            style={titleColor ? { color: titleColor } : {}}
            className="mt-lg-4 mt-2 text-uppercase"
          />
          <div className="d-flex justify-content-start align-items-center mt-lg-3 mt-lg-1 mt-0">
            <p>Estado:</p>
            <p className="ps-1">{getStatus(development)}</p>
          </div>{' '}
          <p>
            {`${getLocation(
              development as Development,
            )}, ${development?.location?.full_location.split(' | ')[0]}`}
          </p>{' '}
        </Col>
      </Row>
    </section>
  )
}

export default CardDevelopment8
